import template from './topdata-reg-attempt-log-list.html.twig';
import './topdata-reg-attempt-log-list.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;
const { date } = Shopware.Utils.format;
const { Application } = Shopware;

Shopware.Component.register('topdata-reg-attempt-log-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            naturalSorting: false,
            total: 0,
            emailSearchTerm: '',
            emailSearchTimeout: null,
            showClearModal: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_registration_attempt_log');
        },

        columns() {
            return [
                {
                    property: 'email',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.email'),
                    allowResize: true,
                    primary: true,
                },
                {
                    property: 'attemptType',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.attemptType'),
                    allowResize: true,
                },
                {
                    property: 'conflictType',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.conflictType'),
                    allowResize: true,
                },
                {
                    property: 'createdAt',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.createdAt'),
                    allowResize: true,
                },
            ];
        },
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('customer');

            const emailTerm = this.emailSearchTerm ? this.emailSearchTerm.trim() : '';
            if (emailTerm) {
                criteria.addFilter(Criteria.contains('email', emailTerm));
            }

            return this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.items = result;
                this.total = result.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onEmailSearchInput() {
            if (this.emailSearchTimeout) {
                clearTimeout(this.emailSearchTimeout);
            }
            this.emailSearchTimeout = setTimeout(() => {
                this.page = 1;
                this.getList();
            }, 300);
        },

        beforeDestroy() {
            if (this.emailSearchTimeout) {
                clearTimeout(this.emailSearchTimeout);
            }
        },

        getAttemptTypeLabel(attemptType) {
            return this.$tc(`TopdataContactLoginSW6.regLog.attemptType.${attemptType}`, 0, attemptType);
        },

        getConflictTypeLabel(conflictType) {
            return this.$tc(`TopdataContactLoginSW6.regLog.conflictType.${conflictType}`, 0, conflictType);
        },

        getConflictTypeVariant(conflictType) {
            const variants = {
                customer_exists: 'danger',
                contact_exists: 'warning',
            };
            return variants[conflictType] || 'info';
        },

        formatDate(value) {
            if (!value) {
                return '';
            }
            return date(value, {
                hour: '2-digit',
                minute: '2-digit',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },

        onClear() {
            this.showClearModal = true;
        },

        onConfirmClear() {
            this.showClearModal = false;
            this.isLoading = true;

            const httpClient = Application.getContainer('init').httpClient;
            httpClient.post('_action/topdata-contact-login-sw6/reg-log/clear', {})
                .then(() => {
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.regLog.list.clearSuccess'),
                    });
                    this.getList();
                })
                .catch(() => {
                    this.createNotificationError({
                        message: this.$tc('TopdataContactLoginSW6.regLog.list.clearError'),
                    });
                    this.isLoading = false;
                });
        },

        onCancelClear() {
            this.showClearModal = false;
        },

        onDownloadCsv() {
            const httpClient = Application.getContainer('init').httpClient;
            httpClient.get('_action/topdata-contact-login-sw6/reg-log/export', {
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'registration-attempt-log.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(() => {
                this.createNotificationError({
                    message: this.$tc('TopdataContactLoginSW6.regLog.list.exportError'),
                });
            });
        },
    },
});
